import { render } from "./custom-field.vue?vue&type=template&id=23bbe0ce&scoped=true&ts=true"
import script from "./custom-field.ts?vue&type=script&scoped=true&lang=ts"
export * from "./custom-field.ts?vue&type=script&scoped=true&lang=ts"

import "./custom-field.vue?vue&type=style&index=0&id=23bbe0ce&scoped=true&lang=css"

import exportComponent from "/usr/src/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23bbe0ce"]])

export default __exports__